<section class="flex w-full min-w-0 flex-col gap-6 rounded-2xl bg-lGray900 p-7">
  <h2 class="text-3xl font-semibold text-lWhite">Certificados</h2>

  @switch (state()) {
    @case ('loading') {
      <div class="flex items-center justify-center py-10" data-testid="certificates-loading">
        <l-spinner />
      </div>
    }

    @case ('forbidden') {
      <p class="text-lSecondary" data-testid="certificates-forbidden">
        Você não tem permissão para visualizar certificados.
      </p>
    }

    @case ('error') {
      <div class="flex flex-col items-start gap-4" data-testid="certificates-error">
        <p class="text-lSecondary">{{ errorMessage() }}</p>
        <button
          type="button"
          lButton
          class="!w-auto px-6"
          [bType]="buttonTypeEnum.PRIMARY"
          [bRadius]="buttonRadiusEnum.CIRCLE"
          (click)="loadCertificates()"
        >
          Tentar novamente
        </button>
      </div>
    }

    @default {
      @if (isEmpty()) {
        <p class="text-lSecondary" data-testid="certificates-empty">
          Você ainda não possui certificados. Conclua um curso para receber o seu.
        </p>
      }

      @if (certificates().length > 0) {
        <ul class="flex flex-col gap-3" data-testid="certificates-list">
          @for (certificate of certificates(); track certificate.id) {
            <li class="flex flex-col gap-4 rounded-xl bg-lSecondary/10 p-5 sm:flex-row sm:items-center sm:justify-between">
              <div class="flex min-w-0 items-start gap-4">
                <l-icon class="text-3xl text-lPrimary" icon="emoji_events" />

                <div class="flex min-w-0 flex-col gap-1">
                  <p class="truncate text-lg font-semibold text-lWhite">{{ certificate.courseTitle }}</p>

                  <p class="text-sm text-lSecondary">
                    Concluído em {{ certificate.completedAt | date: 'dd/MM/yyyy' }}
                    @if (formatDuration(certificate.courseDurationMinutes); as duration) {
                      · Carga horária: {{ duration }}
                    }
                  </p>

                  <p class="break-all text-xs text-lSecondary/70">Código: {{ certificate.id }}</p>
                </div>
              </div>

              <button
                type="button"
                lButton
                class="!w-auto shrink-0 px-6"
                [bType]="buttonTypeEnum.PRIMARY"
                [bRadius]="buttonRadiusEnum.CIRCLE"
                [disabled]="isDownloading(certificate.id)"
                [attr.aria-label]="'Baixar certificado de ' + certificate.courseTitle"
                (click)="onDownload(certificate)"
              >
                {{ isDownloading(certificate.id) ? 'Baixando...' : 'Baixar' }}
              </button>
            </li>
          }
        </ul>
      }

      @if (pendingCourses().length > 0) {
        <div class="flex flex-col gap-3" data-testid="certificates-pending">
          <h3 class="text-lg font-medium text-lWhite">Concluídos sem certificado</h3>

          <ul class="flex flex-col gap-3">
            @for (course of pendingCourses(); track course.courseId) {
              <li class="flex flex-col gap-4 rounded-xl border border-lWarning/40 p-5 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex min-w-0 flex-col gap-1">
                  <p class="truncate font-semibold text-lWhite">{{ course.title }}</p>
                  <p class="text-sm text-lSecondary">
                    Curso concluído, mas o certificado ainda não está disponível.
                  </p>
                </div>

                @if (canIssue) {
                  <button
                    type="button"
                    lButton
                    outline
                    class="!w-auto shrink-0 px-6"
                    [bType]="buttonTypeEnum.PRIMARY"
                    [bRadius]="buttonRadiusEnum.CIRCLE"
                    [disabled]="isIssuing(course.courseId)"
                    (click)="onIssue(course)"
                  >
                    {{ isIssuing(course.courseId) ? 'Emitindo...' : 'Emitir certificado' }}
                  </button>
                }
              </li>
            }
          </ul>
        </div>
      }
    }
  }
</section>
